import React from "react";
import { DatePicker, TimePicker } from "antd";
import { RenderDateInput } from "app/common/renderInput";
const format = "HH:mm";
const onChange = (date, dateString) => {
  console.log(date, dateString);
};
const DateDept = ({
  index,
  // handleBlur,
  values,
  handleChange,
  touched,
  errors,
}) => {
  return (
    <RenderDateInput
      type="date"
      id={`flightLegs.return[${index}].departureDate`}
      name={`flightLegs.return[${index}].departureDate`}
      // display="Request Date"
      // onBlur={handleBlur}
      value={values?.flightLegs?.return[index]?.departureDate}
      onChange={handleChange}
    ></RenderDateInput>
  );
};

export default DateDept;
